import React, { Component } from 'react';
import '../App.css';
import {Link} from 'react-router-dom';
import Dropzone from 'react-dropzone';
import autosize from 'autosize';
/* global moment */
/* global $ */
/* global opr */
/* global safari */

export default class MakeBlog extends Component {
  constructor(props){
    super(props);
    this.state = {
      'user_names': {},
      'preview': false,
      'image_files': {},
      'blog_imgs': [],
      'blog_text': '',
      'blog_title': '',
      'editing': false,
      'editing_id': '',
      'delete_id': null,
    };
  }
  
  load_user_name(uid) {
    let firebase = this.props.app_state.firebase;
    firebase.database().ref('/main/users/'+uid+'/name').on('value', (snap) => {
      let user_names = this.state.user_names;
      user_names[uid] = snap.val();
      this.setState({'user_names': user_names});
    });
  }
  img_drop(files) {
    
    let id_count = 0;
    let this_id;
    
    let state_img_files = this.state.image_files;
    let curr_text;
    let xml_id;
    
    files.forEach((img) => {
      this_id = img.name.replace(/\W/g, '').toLowerCase();
      xml_id = 'image_'+Date.now()+'_'+Math.floor(Math.random()*1000);
      state_img_files[this_id] = {'file': img, 'id': this_id, 'xml_id': xml_id};
      curr_text = $('#edit_blog_content').val();
      $('#edit_blog_content').val(
        curr_text + '\n[image '+this_id+']\n'
      );
      autosize.update($('#edit_blog_content'));
      
      $('#image_holder').append('\
        <div class="img_preview_cont">\
          <p>'+this_id+'</p>\
          <img id="'+xml_id+'" class="img_preview">\
        </div>');
      $('#'+xml_id).attr('src', img.preview);      
    });
    this.setState({'image_files': state_img_files});
  }
  
  browser = '';
  post_blog() {
    window.scroll({
      'top': 0, 
      'left': 0,
      'behavior': 'smooth',
    });
      
    let raw_text = $('#edit_blog_content').val();
    
    let blog_text = '';
    let blog_imgs = [];
    
    let still_looking = true;
    let curr_index;
    let end_index;
    let image_name;
    let img_index;
    while(still_looking) {
      still_looking = false;
      curr_index = raw_text.indexOf('[image');
      if (curr_index >= 0) {
        still_looking = true;
        
        // when you find the keyword [image, put half into blog_text, 
        // and keep working on other half
        blog_text += raw_text.slice(0, curr_index);
        raw_text = raw_text.slice(curr_index+6);
        end_index = raw_text.indexOf(']');
        image_name = raw_text.slice(0, end_index).replace(/\s/g, '');
        raw_text = raw_text.slice(end_index+1);
        if (raw_text[0] === '\n')
          raw_text = raw_text.slice(1);
        img_index = blog_text.length;
        
        blog_imgs.push({
          'position': img_index,
          'id': image_name,
          'file': this.state.image_files[image_name].file,
          'in_cloud': this.state.image_files[image_name].in_cloud||false,
          'url': this.state.image_files[image_name].url||undefined,
        });        
      }
      else
        blog_text += raw_text;
    }
    
    this.setState({
      'preview': true,
      'blog_text': blog_text,
      'blog_imgs': blog_imgs,
      'blog_title': $('#post_name').val(),
    }, () => {
      let key
      if (this.state.editing)
        key = this.state.editing_id;
      console.log(key)
    });    
  }
  post_confirm() {
    let firebase = this.props.app_state.firebase;
    let key = this.state.blog_title.replace(/\W/g, '').toLowerCase();
    if (!key || key.length === 0) {
      $('#alert_danger').text('Please enter a valid title').fadeIn().delay(2000).fadeOut();
      this.cancel();
      return;
    }
    if (!this.state.blog_text || this.state.blog_text.length === 0) {
      $('#alert_danger').text('Please enter some content').fadeIn().delay(2000).fadeOut();
      this.cancel();
      return;
    }
    $('#alert_working').fadeIn().delay(1000).fadeOut();
    
    let for_state = {};
    // dup check 
    firebase.database().ref('/main/blog_posts').once('value', (snap) => {
      let b_posts = snap.val();
      
      if (this.state.editing)
        key = this.state.editing_id;
      else {
        let existing_keys = [];
        if (b_posts) 
          existing_keys = Object.keys(b_posts);
        
        if (existing_keys.includes(key)) {
          let key_counter = 0;
          let temp_key = key;
          while (existing_keys.includes(temp_key)) {
            temp_key = key+key_counter;
            key_counter++;
          }
          key = temp_key;
        }
      }
      
      
      let this_user = this.props.app_state.this_user;
      for_state[key+'/id'] = key;
      for_state[key+'/author'] = this_user.id;
      for_state[key+'/author_name'] = this_user.name;
      for_state[key+'/pub_time'] = Date.now();
      for_state[key+'/text'] = this.state.blog_text;
      for_state[key+'/title'] = this.state.blog_title;
      for_state[key+'/url'] = 'https://minusthenegative-1fd3c.firebaseapp.com/blog/'+key;
      for_state[key+'/images'] = [];
      
      function get_sum(total, num) {
        return total + num;
      }
      
      console.log('key is ', key)
      let prom_list = [];
      let num_imgs = 0;
      let progress_bucket = [];
      $('#alert_dark').text('Uploading...').fadeIn();
      let blog_imgs = this.state.blog_imgs;
      let img_names = [];
      let in_cloud_names = [];
      blog_imgs.forEach((img) => {
        if(img.in_cloud)
          in_cloud_names.push(img.id);        
      });
      blog_imgs.forEach((img, index) => {
        if (img.in_cloud) {
          img_names.push(img.id);
          return;
        }
        
        let temp_key = img.id;
        let key_counter = 0;
        while (img_names.includes(temp_key) 
                  || in_cloud_names.includes(temp_key)) {
          temp_key = img.id.split('.').slice(0, -1).join('.') + key_counter +'.'
                          + img.id.split('.').slice(-1);
          key_counter++;
        }
        
        blog_imgs[index].id = temp_key;
        img_names.push(img.id);        
      });
      blog_imgs.forEach((img, index) => {
        num_imgs++;
        prom_list.push(
          new Promise((resolve, reject) => {            
            if (img.in_cloud) {              
              for_state[key+'/images'][index] = {
                'position': img.position,
                'url': img.url,
                'name': img.id,
              };       
              console.log(img, 'is in cloud', for_state)
              // clone for_state
              return resolve(JSON.parse(JSON.stringify(for_state)));
            }
            
            console.log('uploading', img)
            
            let task = firebase.storage().ref('main/user/'+this.props.app_state.this_user.firebase_id
                                      +'/'+key+'/images/'+img.id).put(img.file);
            
            task.on(firebase.storage.TaskEvent.STATE_CHANGED,
              (snap2) => {
                progress_bucket[index] = (snap2.bytesTransferred / snap2.totalBytes) * 100;
                $('#alert_dark').text('Uploading... '
                                            +parseInt(progress_bucket.reduce(get_sum)/num_imgs, 10)
                                            +'%');// to int
                
                switch (snap2.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    $('#alert_dark').text('Upload paused at '
                                              +parseInt(progress_bucket.reduce(get_sum)/num_imgs, 10)
                                              +'%');
                    break;
                  case firebase.storage.TaskState.RUNNING: // or 'running'
                    break;
                  default:
                    break;
                }
              }, (error) => {                
                $('#alert_dark').fadeOut();
                $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();  
                reject();
                console.log('error', error)
              }, () => {
                // Upload completed successfully, now we can get the download URL
                task.snapshot.ref.getDownloadURL().then((download_URL) => {
                  $('#alert_dark').text('Upload finished');
                  
                  for_state[key+'/images'][index] = {
                    'position': img.position,
                    'url': download_URL,
                    'name': img.id,
                  };       
                  console.log('done uploading', for_state)
                  
                  // clone for_state
                  resolve(JSON.parse(JSON.stringify(for_state)));
                });
              })
          })
        );
      });     
      
      Promise.all(prom_list).then(() => {
        console.log('pushing', for_state)
        firebase.database().ref('/main/blog_posts/').update(for_state)
          .then(() => {
            $('#alert_dark').text('Blog Post Published').fadeIn().delay(2000).fadeOut();
            if (!this.state.editing)
              this.setState({'editing': true, 'editing_id': key});
          })
          .catch((error) => {
            $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
          });
      })
    });       
  }
  cancel() {
    this.setState({
      'preview': false,
      'blog_text': '',
      'blog_imgs': [],
      'blog_title': '',
    });
  }
  delete_ask(bid) {
    this.setState({'delete_id': bid});
    $('#delete_ask').modal('show');
  }
  confirm_delete(bid) {
    let firebase = this.props.app_state.firebase;
    let for_db = {};
    for_db[bid] = null;
    firebase.database().ref('/main/blog_posts/').update(for_db)
    .then(() => {
      $('#alert_dark').text('Blog post deleted').fadeIn().delay(1500).fadeOut();
    })
    .catch((error) => {      
      $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
    });
    $('#delete_ask').modal('hide');
  }
  
  load_blog(bid) {
    let firebase = this.props.app_state.firebase;
    
    firebase.database().ref('/main/blog_posts/'+bid).once('value', (snap) => {
      let post = snap.val();
      let text = post.text;
      let raw_text = '';
      let last_index = 0;
      let this_img;
      let img_name;
      let ques_index;
      let state_imgs = {};
      let xml_id;
      $('#image_holder').html('');
      
      for(let i = 0; i < (post.images||[]).length; i++) {
        this_img = post.images[i];
        raw_text += text.slice(last_index, this_img.position);
        last_index = this_img.position;
        
        img_name = this_img.name;
        if (!img_name) {
          ques_index = this_img.url.indexOf('?');
          if (ques_index >= 0)
            img_name = this_img.url.slice(0, ques_index);
          
          img_name = img_name.split('%2F');
          img_name = img_name[img_name.length - 1];
        }
        
        state_imgs[img_name] = {
          'id': img_name,
          'in_cloud': true,        
          'file': {'name': img_name, 'preview': this_img.url},
          'url': this_img.url,
        }
        
        raw_text += '[image '+img_name+']\n';
        
        xml_id = 'image_'+Date.now()+'_'+Math.floor(Math.random()*1000);
        $('#image_holder').append('\
          <div class="img_preview_cont">\
            <p>'+img_name+'</p>\
            <img id="'+xml_id+'" class="img_preview">\
          </div>');
        $('#'+xml_id).attr('src', this_img.url);  
      }
      raw_text += text.slice(last_index);
      
      $('#post_name').val(post.title);
      $('#edit_blog_content').val(raw_text);    
      autosize.update($('textarea'));  
      
      this.setState({'editing': true, 'editing_id': bid, 'image_files': state_imgs});
    });
    
  }
  
  componentDidUpdate() {    
    autosize($('textarea'));
  }
  
  componentDidMount (){
    $("#edit_blog_content").keydown(function(e){
      // Enter was pressed with shift key
      if (e.keyCode === 13 && e.shiftKey)
      {
          // prevent default behavior
          e.preventDefault();
      }
    });    
    
    $('#delete_ask').on('hidden.bs.modal', (e) => {
      this.setState({'delete_id': null});
    })
    
    autosize($('textarea'));
  }
   
  render() {
    let blogs_xml = [];
    let author;
    this.props.app_state.blogs.forEach((this_blog) => {
      let bid = this_blog.id;
      author = this.state.user_names[this_blog.author];
      if (typeof author === 'undefined') {
        author = this_blog.author;
        this.load_user_name(author);
      }
      
      let blog_btns = [];
      if (true) {
        blog_btns.push(<hr/>);
        blog_btns.push(<Link to={"/blog/"+this_blog.id}>
          <button className="btn btn-dark edit_blog_btn">View</button>
        </Link>);        
        blog_btns.push(
          <button className="btn btn-dark edit_blog_btn edit_blog_mid"
                    onClick={this.load_blog.bind(this, bid)}>Edit</button>
        );        
        blog_btns.push(
          <button onClick={this.delete_ask.bind(this, bid)} 
            className="btn btn-outline-danger edit_blog_btn">Delete</button>
        );
      }
      blogs_xml.push(<div className={"blog_container"}>
        <t className="blog_title">{this_blog.title}</t><br/>
        <t className="blog_date">
          {(this_blog.pub_time)?moment(this_blog.pub_time).format('MM/D/YY'):''}
        </t>
        <t className="blog_content">{this_blog.text.substring(0, 200)}...</t>
        {blog_btns}
      </div>);
    });
    
    let preview = null;
    if (this.state.preview) {      
      let blog_list = [];
      let last_index = 0;
      this.state.blog_imgs.forEach((img) => {
        blog_list.push(
          <p>{this.state.blog_text.slice(last_index, img.position)}</p>
        );
        blog_list.push(
          <img src={img.file.preview} alt={img.file.name}/>
        );
        last_index = img.position;
      });
      blog_list.push(
        <p>{this.state.blog_text.slice(last_index)}</p>
      );
      
      preview = <div id="makeblog_preview">
        <h4>Preview</h4>
        <div id="blog_btn_container">
          <button onClick={this.post_confirm.bind(this)} className="btn btn-dark">Post</button>
          <button onClick={this.cancel.bind(this)} className="btn btn-outline-danger">Cancel</button>
        </div>
        <hr/>
        <h1>{this.state.blog_title}</h1>
        <hr/>
        <div id="makeblog_preview_content">
          {blog_list}
        </div>
      </div>;
    }
    
    return (
      <div id="makeblog_div">
        {preview}
        <div className="row">
          <div className="col-md-6">
            <h3>New Blog Post</h3>
            <input id="post_name"
                                type="text" className="form-control" 
                                placeholder="Post Title" aria-label="Post Name" />
            <textarea id="edit_blog_content" aria-label="Post Content"
                  className="form-control"
                  placeholder="Post Content">              
            </textarea>
            <div id="image_holder">
            </div>
            <p id="blog_img_warning">Warning: Images are stored by their names, so make sure that each image has a unique name.</p>
            <Dropzone multiple={true}
                      accept="image/*"
                      onDrop={this.img_drop.bind(this)}
                      className="makeblog_dropzone"
                      acceptClassName="makeblog_dropzone_accept"
                      rejectClassName="makeblog_dropzone_reject">
              <p>Drop an image or click to select a file to upload.</p>
            </Dropzone>
            <button id="makeblog_post"
                    className="btn btn-dark"
                    onClick={this.post_blog.bind(this)}>Preview</button>
    
          </div>
          <div className="col-md-6">
            <h3>Blog Posts</h3>
            {blogs_xml}
          </div>
        </div>
        
        <div id="delete_ask" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Are you sure?</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal_body">
              <strong>You are about to delete the blog post:</strong><br/>
              <em>{this.state.delete_id}</em><br/>
              <strong>Please confirm</strong>
            </div>
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.confirm_delete.bind(this, this.state.delete_id)} type="button" className="btn btn-dark">Confirm</button>
              <button type="button" className="btn btn-outline-danger" 
                        data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>  
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MakeBlog.js